import { render, staticRenderFns } from "./AppGetPosts.vue?vue&type=template&id=5ab93042&scoped=true&"
import script from "./AppGetPosts.vue?vue&type=script&lang=js&"
export * from "./AppGetPosts.vue?vue&type=script&lang=js&"
import style0 from "./AppGetPosts.vue?vue&type=style&index=0&id=5ab93042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab93042",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/AppGetPosts.vue
// module id = 80
// module chunks = 0